/**
 * File Storage API Endpoints
 * Константы endpoints для микросервиса file-storage.
 */

export const FileStorageEndpoints = {
  FileStorage: "file-storage",
} as const;
